import React from "react";
import Grid from "@material-ui/core/Grid";
class WhiteButton extends React.Component{
    constructor() {
        super();
    }
    render() {
        const {backgroundColor,text}=this.props.data
        return(
            <Grid className='white-button'  style={{backgroundColor:backgroundColor,width:'100%'}}>
                <p style={{direction:'ltr'}} id='invitation-text'>
                    {text} کد معرف شما
                </p>
            </Grid>
        )
    }
}
export default WhiteButton